import React from 'react';

import { SelectedLocationProps } from './BlockBuilderDynamicDealerPricing';

function SelectedLocation({
  zipCode,
  activeDealer,
  locationSearchHeading,
  handleChangeLocation,
  className = '',
}: Readonly<SelectedLocationProps>) {
  return (
    <div
      className={`flex flex-col gap-2 items-start self-center max-w-xs ${className}`}
    >
      <div>
        <p className="m-0 text-sm leading-[115%]">
          {locationSearchHeading || 'Estimated pricing for'}
        </p>
        {(zipCode || activeDealer?.address?.zip) && (
          <p className="m-0 text-foreground-headline text-xl font-bold leading-[115%]">
            {zipCode || activeDealer?.address?.zip}
          </p>
        )}

        {activeDealer?.name && (
          <p className="m-0 text-foreground-headline text-lg font-bold leading-[115%]">
            {activeDealer.name}
          </p>
        )}
      </div>
      <button
        type="button"
        onClick={handleChangeLocation}
        className="text-foreground-link underline hover:no-underline leading-6"
      >
        Change Location
      </button>
    </div>
  );
}

export default SelectedLocation;
